export default "__VITE_ASSET__DE2T58VN__";